<h2 mat-dialog-title>
  <span style="padding-right: 3px" translate>Alerts for</span>
  <student-name *ngIf="student != undefined" [firstName]="student.FirstName" [lastName]='student.LastName'
    [middleName]='student.MiddleName'></student-name>
</h2>
<mat-dialog-content>
  <table mat-table [dataSource]="alerts" class="mat-elevation-z0">
    <!-- Alert Icon Column -->
    <ng-container matColumnDef="alertIcon">
      <th mat-header-cell *matHeaderCellDef style="width:70px;"><span translate>Alert</span></th>
      <td mat-cell *matCellDef="let alert" style="width:70px;">
        <img class="alertImage" *ngIf="alert.AlertType == 'IEP'" src="./assets/images/iep.png" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Medical Alert' && isV10"
          src="./assets/images/alerthealthv10.png" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Medical Alert' && !isV10"
          src="./assets/images/alertmedical.gif" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Family Alert'" src="./assets/images/alertfamilyv10.png" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Release Alert'" src="./assets/images/alertrelease.gif" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Programs And Services Alert' && !useSection504"
          [src]="'data:image/jpg;base64,' + alert.AlertIcon" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Programs And Services Alert' && alert.Program != '504' && useSection504"
          [src]="'data:image/jpg;base64,' + alert.AlertIcon" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Programs And Services Alert' && alert.Program == '504' && useSection504"
          src="./assets/images/PS_504_ELIG.jpeg" />
        <img class="alertImage" *ngIf="alert.AlertType == 'Classroom Alert'"
          src="./assets/images/student notes alert.png" />
        <img class="alertImage" *ngIf="alert.AlertType == '504 Special Service'"
          src="./assets/images/PS_504_ELIG.jpeg" />
      </td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef><span style="padding-left: 15px;" translate>Description</span></th>
      <td mat-cell *matCellDef="let alert" [ngStyle]="{'color':alert.IsConfidential ? 'red' : 'black' }">
        <tyl-quill-text-only [displayBorder]="false" [html]="alert.Description" placeholder="" *ngIf="(this.isV10 && alert.AlertType != 'IEP')
        || (alert.AlertType != 'Programs And Services Alert' && alert.AlertType != 'IEP' && alert.AlertType != '504 Special Service')
        || (!alert.UserHasPermisison && alert.Description != '')" class="remove-ql-editor-margin">
        </tyl-quill-text-only>

        <span *ngIf="!this.isV10 && alert.AlertType == 'Programs And Services Alert'
          && !alert.UserHasPermisison && alert.Description != ''" style="padding-left: 15px;">
          {{alert.Program}} - {{alert.Service}}
        </span>

        <a *ngIf="!this.isV10 && alert.AlertType == 'Programs And Services Alert'
         && (alert.UserHasPermisison || alert.Description == '')"
          (click)="programServiceClick(alert.Program, alert.Service)" style="padding-left: 15px;">
          {{alert.Program}} - {{alert.Service}}
        </a>

        <a *ngIf="alert.AlertType == 'IEP' && alert.UserHasPermisison" (click)="iepClick(alert)"
          style="padding-left: 15px;">
          {{alert.Description}}
        </a>
        <a *ngIf="alert.AlertType == '504 Special Service' && alert.UserHasPermisison" (click)="iepClick(alert)"
          style="padding-left: 15px;">
          {{alert.Description}}
        </a>
      </td>
    </ng-container>

    <!-- Start Column -->
    <ng-container matColumnDef="start">
      <th mat-header-cell *matHeaderCellDef style="width:85px;"><span translate>Start</span></th>
      <td mat-cell *matCellDef="let alert" style="width:85px;">{{alert.StartDate}}</td>
    </ng-container>

    <!-- End Column -->
    <ng-container matColumnDef="end">
      <th mat-header-cell *matHeaderCellDef style="width:85px;"><span translate>End</span></th>
      <td mat-cell *matCellDef="let alert" style="width:85px;">{{alert.EndDate}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <tyl-button style="float:right;" image="Cancel.png" label="Close" (clickEvent)="closeClick()" translate>
    </tyl-button>
  </div>
</mat-dialog-actions>